'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getTabsOrder, getTabsById } from 'DesignData/selectors/tabs';
import AllTabsMenu from 'DesignManagerIde/components/tabs/AllTabsMenu';
import * as TabsActions from 'DesignData/actions/Tabs';

class AllTabsMenuContainer extends Component {
  render() {
    return /*#__PURE__*/_jsx(AllTabsMenu, Object.assign({}, this.props));
  }

}

function makeMapStateToProps() {
  return function mapStateToProps(state) {
    return {
      tabsById: getTabsById(state),
      tabsOrder: getTabsOrder(state)
    };
  };
}

const mapDispatchToProps = {
  openTab: TabsActions.openTab,
  closeTabs: TabsActions.closeTabs
};
AllTabsMenuContainer.propTypes = {
  tabsById: PropTypes.object.isRequired,
  tabsOrder: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])).isRequired,
  openTab: PropTypes.func.isRequired,
  closeTabs: PropTypes.func.isRequired
};
export default connect(makeMapStateToProps, mapDispatchToProps)(AllTabsMenuContainer);